import styled from 'styled-components'

// Note: the width lives on the form itself (not a wrapper) - the Modal is `autoWidth`, so it
// sizes to this; maxWidth keeps it inside the full-screen mobile sheet.
export const StyledForm = styled.form(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
  maxWidth: '100%',
  width: '47rem',
}))

export const Row = styled.div(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  gap: theme.space['8'],
}))

export const FullWidthField = styled.div({
  flex: 1,
})

export const ShortField = styled.div({
  width: '6.5rem',
})

export const HalfWidthRow = styled.div(({ theme }) => ({
  '> div': {
    flex: 1,
  },
  display: 'flex',
  gap: theme.space['8'],
}))
